export default {
  create: {
    success: 'Mot(s) clé(s) ajouté(s) avec succès',
    error: 'Impossible de supprimer les mot(s) clé(s)'
  },
  delete: {
    success: 'Mots-clés supprimés',
    error: 'Impossible de supprimer les mots-clés'
  },
  import: {
    success: 'Mots-clés importés',
    error: "Impossible d'importer les mots-clés"
  }
}
